import React from "react";

import { FullScreenOverlay, GatedVimeo } from "components";

type VideoOverlayProps = {
  visible: boolean;
  vimeoId: string;
  onClose: () => void;
};

export const VideoOverlay = ({ visible, vimeoId, onClose }: VideoOverlayProps) => (
  <FullScreenOverlay
    dataTestId="video-overlay"
    showModal={visible}
    onClose={onClose}
    className="video-overlay"
    wrapClassName="full-screen-overlay video-overlay-wrapper"
    maskClosable={true}
  >
    <div className="video-overlay-video-container">
      {visible && <GatedVimeo video={vimeoId} autoplay responsive showByline={false} showPortrait={false} showTitle={false} />}
    </div>
  </FullScreenOverlay>
);
